// api.js
import axios from 'axios';

// const API_BASE_URL = 'http://192.46.221.102:8080'; // Update your backend URL/PORT
const API_BASE_URL = 'https://linode.qoipr.com'; // Update your backend URL/PORT

export const syncProducts = () => axios.get(`${API_BASE_URL}/syncProducts`);

export const searchProducts = (query, page, perPage, filterBy = '', sortBy = '') => axios.get(`${API_BASE_URL}/searchProducts`, {
  params: { q: query, page: page, perPage: perPage, filterBy: filterBy, sortBy: sortBy || undefined }
});
